// extracted by mini-css-extract-plugin
export default {"active_tab":"styles_active_tab__c1TeD"};